module.exports = __webpack_public_path__ + "img/shenzihong.fd8e670f.png";